import React from "react";
import { Route, Navigate } from "react-router-dom";

// Home Routes
import HomePage from "./home-page/HomePage";

// Arboretum
import Arboretum from "./arboretum/Arboretum";
import Tree from "./arboretum/tree/Tree";
import Constellation from "./arboretum/constellation/Constellation";
import Seed from "./arboretum/seed/Seed";
// Magic Items
import MagicItem from "./magic-item/MagicItem";

// Wrappers
import CorralPageWrapper from "./CorralPageWrapper";

const CorralPages = () => [
  <Route
    index
    key="corral/index"
    element={<Navigate to="homepage" replace />}
  />,
  <Route path="homepage" key="corral/homepage" element={<HomePage />} />,
  // Arboretum Routes
  <Route path="arboretum" key="corral/arboretum" element={<Arboretum />} />,
  <Route
    path="arboretum/:treeId"
    key="corral/arboretum/tree"
    element={<Tree />}
  />,
  <Route
    path="arboretum/:treeId/constellation/:quadrantId"
    key="corral/arboretum/tree/constellation"
    element={<Constellation />}
  />,
  <Route
    path="arboretum/:treeId/seed/:quadrantId"
    key="corral/arboretum/tree/seed"
    element={<Seed />}
  />,
  // Magic Item Routes
  <Route path="magic-item" key="corral/magic-item" element={<MagicItem />} />,
];

export default () => (
  <Route path="corral" key="corral" element={<CorralPageWrapper />}>
    {CorralPages()}
  </Route>
);
